<div class="flex flex-col gap-4 p-4">
  <h1 class="text-2xl leading-snug">Verpflegung</h1>
  <div class="flex flex-col gap-2">
    <p>Buchen Sie auf Wunsch <span class="font-semibold">zusätzliche</span> Produkte oder Pakete hinzu</p>
    <div class="flex flex-col gap-4">
      @for (product of progressService.selectedAdditionalProducts(); track product.id) {
        <div class="flex flex-col pb-4 border-b-[1px] border-benzGrey-200 gap-2">
          <h2>{{ product.name_public }}: {{ (+(product.price) + (+(product.bediengeld || 0))) | currency:'EUR' }}</h2>
          <div class="flex w-full justify-between">
            <div class="flex h-12">
              <button
                class="h-full touch-manipulation w-12 z-10 -mr-[10px] sm:mr-0 bg-white p-2 border-benzGrey-900 rounded-l-lg border-2 border-r-0"
                (click)="decreaeseAmount(product)">-
              </button>
              <input
                class="h-full touch-manipulation w-[55px] text-center sm:w-auto border-benzGrey-900 border-t-2 border-b-2"
                min="0" step="1" [value]="product.pivot!.amount" type="number"
                [max]="progressService.selectedPersons()! * 10" (change)="setAmount(product, $event)" />
              <button
                class="h-full touch-manipulation w-12 z-10 -ml-[15px] sm:ml-0 bg-white p-2 border-benzGrey-900 rounded-r-lg border-2 border-l-0"
                (click)="increaseAmount(product)">+
              </button>
            </div>
            <span>{{ (+(product.price) + (+(product.bediengeld || 0))) * (product.pivot!.amount || 0) | currency:'EUR' }}</span>
          </div>
        </div>
      }
      <div class="flex w-full justify-between">
        <span class="text-xl">Zwischensumme</span><span>{{ selectedTokenSum() | currency:'EUR' }}</span>
      </div>
    </div>
    <button routerLink="/booking/shipping" class="px-8 py-4 bg-benzRed-700 text-white rounded-lg" #advandeButton>Produkte
      hinzufügen
    </button>
  </div>
</div>
